module.exports = __webpack_public_path__ + "static/portfolio-5-53e59cd2b14b4413967d7a7db71e406d.png";